import { PayMCopyDateModeAddExtended } from '../../../../../../../../specificComponents/inputTableLayouts/order/OrderLayout/OrderTable/TableComponents/ModalsOrderTable/ModalOrderPaymentMethod/types'
import { stringToDate } from '../../../../../../../../utils/globals/date'

export const parseManagePaymentMethodDate = (paymentMethodDate: PayMCopyDateModeAddExtended) => {
    let result: PayMCopyDateModeAddExtended []= []
    const copyPaymentDate = JSON.parse(JSON.stringify(paymentMethodDate))
    delete copyPaymentDate.PayMDateCopyLogs
    copyPaymentDate.quantity = parseFloat(String(copyPaymentDate.quantity))
    copyPaymentDate.payment_data = copyPaymentDate?.PayTCopy?.new_extra_payment_data?.id || copyPaymentDate?.PayTCopy?.new_extra_payment_data?.value
    copyPaymentDate.date = stringToDate(copyPaymentDate.date)
    result.push(copyPaymentDate)
    result.push({ subId: 'addButton' })
    return result
}